import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, resolve, reject) {
    if ( resolve || reject ) return originalPush.call(this, location, resolve, reject)
    return originalPush.call(this, location).catch((e)=>{})
}

Vue.use(VueRouter)
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../views/404.vue')
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
    router.matcher = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
}

//动态添加数据
export const setRoutes = () =>{
    const storeMenus = localStorage.getItem("menus");
    // localStorage.removeItem("token")
    // localStorage.clear()
   // console.log("121212",storeMenus)
    if(storeMenus){
        // 获取当前的路由对象名称数组
        const currentRouteNames = router.getRoutes().map(v => v.name)
        if (!currentRouteNames.includes('Home')) {
            const menus = JSON.parse(storeMenus)
           // console.log('menus',menus)
            const redirectName = menus ? "/"+ (menus[0].children.length > 0 ?  menus[0].children[0].url : menus[0].url) : "/404"
            // const redirectName = "/safetyS/monitor"
            // 拼装动态路由
            const manageRoute = { path: '/', name: 'Home', component: () => import('../components/Home.vue'), redirect: redirectName, children: [] }
            var thirdAuthority ={};
            menus.forEach((item,index) => {
                if(item.route){
                    let itemMenu = {
                        path: item.url,
                        name: item.route,meta: {title: item.label,check: index},
                        component: () => import('../views/' + item.url +"/"+item.url+ '.vue')
                    }
                    manageRoute.children.push(itemMenu)
                    item.children.forEach((item_,index_) =>{
                        let itemMenu_ ={
                            path: item_.url,
                            name: item_.route,
                            meta:{
                                title: item_.label,check: index,sencondcheck:index_
                            },
                            component: () => import('../views/' + item_.url + '.vue')
                        }
                        manageRoute.children.push(itemMenu_)

                        let list = []
                        item_.children.forEach((item3,index3) =>{
                            list.push(item3.label)
                        })

                        thirdAuthority[item_.route] = list.length === 0 ? "all" :list
                    })
                }
            })
            localStorage.setItem("thirdAuthority", JSON.stringify(thirdAuthority))

            // 动态添加到现在的路由对象中去
            router.addRoute(manageRoute)
        }
    }
}
// 重置我就再set一次路由
setRoutes()
router.beforeEach((to, from, next) => {
    const tokenDate = localStorage.getItem("tokenDate")
    //判断token是否生效
    if(tokenDate){
       const dateSecons =new Date().getTime() - tokenDate
       // console.log("dateSecons",dateSecons)
        if(dateSecons > 1000 * 60 * 180){
            localStorage.removeItem("token")
        }
    }

    if (to.meta.title) {
        store.commit('SETHEADNAME', to.meta.title)
        store.commit('SETCHECK', to.meta.check)
        store.commit('SETSECONDCHECK', to.meta.sencondcheck)

    }
    const token = localStorage.getItem('token');

    const currentRouteNames = router.getRoutes().map(v => v.name)

    // 访问login,缓存判断
    if (to.path === '/login') {
        if (token) {
            //有缓存，访问主页
            next('/');
        } else {
            next();
        }
    } else if (to.path !== '/login' && token) {
        // 访问非登录页，有缓存，继续跳转该页面
        next();
    } else if (to.path !== '/login' && !token) {
       // localStorage.clear()
        resetRouter()
        next('/login');
    }
})

export default router
